import { fieldMapByPlatform } from "../constants/fields.constants";

export function filterPostFields(post: any, selectedFields: string[]) {
  const platform = (post.platform || post.soc_source)?.toUpperCase();
  const platformFieldMap = fieldMapByPlatform[platform] || {};
  const generalFieldMap = fieldMapByPlatform.GENERAL || {};

  // Combine both general and platform-specific field maps
  const combinedFieldMap = { ...generalFieldMap, ...platformFieldMap };

  if (!Object.keys(combinedFieldMap).length) return {};

  const filteredPost: Record<string, any> = {};
  const engagementFields: Record<string, any> = {};

  selectedFields.forEach((label) => {
    const mappedKey = combinedFieldMap[label];
    if (!mappedKey) return;

    // Engagement is inside an array, first element
    const engagementObj = Array.isArray(post.engagement)
      ? post.engagement[0]
      : null;
    if (engagementObj && mappedKey in engagementObj) {
      engagementFields[mappedKey] = engagementObj[mappedKey];
      return;
    }

    // Top-level field (not part of engagement)
    if (mappedKey in post) {
      filteredPost[mappedKey] = post[mappedKey];
    }
  });

  if (Object.keys(engagementFields).length > 0) {
    filteredPost.engagement = engagementFields;
  }

  return filteredPost;
}
